








































import { Component, Emit, Watch, Vue } from 'vue-property-decorator';

@Component({
  props: ['operatingSystems'],
})
export default class OperatingSystemSelector extends Vue {
  operatingSystemSelected: any = { id: -1, versions: [] };
  selectedVersion: any = null;
  isAllSystemsShown = false;

  @Watch('selectedVersion')
  onSelectedVersionChanged(val: any) {
    if (val) {
      this.versionSelected();
    }
  }

  @Emit()
  osSelected(system: any) {
    this.operatingSystemSelected = system;
    if (system && system.versions) {
      this.selectedVersion = system.versions[0];
    } else {
      this.selectedVersion = null;
    }
    return system;
  }

  @Emit()
  versionSelected() {
    if (this.selectedVersion) {
      return this.selectedVersion;
    }
  }
}
